import React, { useContext } from 'react';
import { styled } from '@mui/material/styles';

import { useParams } from 'react-router-dom';
import BadgeEdit from './components/BadgeEdit/BadgeEdit';
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { AppContext } from '@/AppContext';
import { MeetupContextProvider } from '@/MeetupContext';

const PREFIX = 'BadgeDetails';

const classes = {
  root: `${PREFIX}-root`,
  contentHeader: `${PREFIX}-contentHeader`,
  content: `${PREFIX}-content`,
};

const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {
    padding: theme.spacing(3),
  },

  [`& .${classes.contentHeader}`]: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    height: '42px',
  },

  [`& .${classes.content}`]: {
    marginTop: theme.spacing(2),
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

const BadgeDetails = () => {
  const { badgeId, mid: meetupId } = useParams();

  return (
    <Root className={classes.root}>
      <MeetupContextProvider meetupId={meetupId}>
        <BadgeEdit badgeId={badgeId} />
      </MeetupContextProvider>
    </Root>
  );
};

export default BadgeDetails;
